import { usePage } from "@inertiajs/react"

import { Badge } from "@/components/ui/badge"
import { Card, CardContent } from "@/components/ui/card"
import { BusinessHoursForm, Schedule, TimezoneOption } from "@/features/schedule/business-hours-form"
import { LocationSectionScreen } from "@/features/staff/location-section-screen"
import { t } from "@/lib/i18n"

type Props = {
  businessHours: Schedule
  timezones: TimezoneOption[]
}

const scope = "ui.react.pages.staff.location.manage.business_hours.show"

export default function StaffLocationManageBusinessHoursShow() {
  const { businessHours, timezones } = usePage<Props>().props

  return (
    <LocationSectionScreen
      title={t(`${scope}.title`)}
      description={t(`${scope}.description`)}
      actions={
        <Badge variant={businessHours.enabled ? "default" : "outline"}>
          {businessHours.enabled ? t(`${scope}.enabled`) : t(`${scope}.disabled`)}
        </Badge>
      }
    >
      <Card>
        <CardContent>
          <BusinessHoursForm schedule={businessHours} timezones={timezones} />
        </CardContent>
      </Card>
    </LocationSectionScreen>
  )
}
